import { useEffect, useState } from "react";
import axios from "axios";
import { apiURI, authErrorRedirect } from "../../common";
import { useNavigate } from "react-router-dom";

export function useSupplierList() {
  const [listOfSuppliers, setListOfSuppliers] = useState([]);
  const [errors, setErrors] = useState();
  const history = useNavigate();

  useEffect(() => {
    axios
      .get(`${apiURI}/form/getSupplierList`)
      .then((response) => {
        setListOfSuppliers(response.data[0].supplierList);
      })

      .catch((error) => {
        console.log(error);
        setErrors();
        setErrors({ response: error.response?.data });
        authErrorRedirect(error.response?.data, history);
      });
    // eslint-disable-next-line no-console
  }, []);

  errors && console.log(errors);
  return { listOfSuppliers };
}
